import type { DrawerMenuItemType } from "@crescentapplications/react-ui";
import packageJson from "../../../package.json";

const drawerMenuItems: DrawerMenuItemType[] = [
  {
    id: "profile",
    kind: "link",
    title: { ar: "الملف الشخصي", en: "Profile" },
    to: "/#profile",
    icon: "user",
  },
  {
    id: "lineage",
    kind: "link",
    title: { ar: "النسب", en: "Lineage" },
    to: "/#lineage",
    icon: "three-users",
  },
  {
    id: "education",
    kind: "link",
    title: { ar: "الدراسة", en: "Education" },
    to: "/#education",
    icon: "contract",
  },
  {
    id: "work",
    kind: "link",
    title: { ar: "الخبرة المهنية", en: "Work Experience" },
    to: "/#work",
    icon: "building",
  },
  {
    id: "volunteering",
    kind: "link",
    title: { ar: "العمل التطوعي", en: "Volunteering" },
    to: "/#volunteering",
    icon: "objects",
  },
  {
    id: "language-toggle",
    kind: "action",
    title: { ar: "English", en: "العربية" },
    icon: "globe",
    action: "toggleLanguage",
  },
  {
    id: "color-scheme",
    kind: "action",
    title: { ar: "نظام الألوان", en: "Color Scheme" },
    icon: "light-dark",
    action: "toggleColorScheme",
  },
  {
    kind: "action",
    id: "refresh-app",
    title: { ar: "إعادة تحميل وتحديث التطبيق", en: "Refresh and Update App" },
    icon: "download",
    action: "custom",
    actionFunction: () => {
      window.location.reload();
    },
  },
  {
    kind: "link",
    id: "version",
    title: {
      ar: `إصدار ${packageJson.version}`,
      en: `Version ${packageJson.version}`,
    },
    icon: "info-circle",
    to: "#",
  },
];

export default drawerMenuItems;
